export default "__VITE_ASSET__b76685a0__"